Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultTheme = {
  columns: 12,
  gutter: {
    xs: 0.5,
    sm: 0.5,
    md: 1,
    lg: 1
  },
  breakpoints: {
    xs: 0,
    sm: 30,
    md: 48,
    lg: 60
  }
};
exports["default"] = defaultTheme;